import React from 'react'
import { Routes, Route } from 'react-router-dom';
import List from './List';
import Details from './Details';
import { Header } from 'semantic-ui-react'
function BriefScheduled() {

  return (
    <>
      <Header as='h2' style={{ marginTop: "50px" }}>
        Scheduled List (no team data)
        <Header.Subheader>
          List of Performance, Practise, Culture Audit, EDI Survey's Scheduled and a place to view them.
        </Header.Subheader>
      </Header>
      <Routes>
        <Route path="/" element={<List />} />
        <Route path="details/:id" element={<Details />} />
      </Routes>
    </>
  );
}

export default BriefScheduled;
